import React from 'react'
import tagIcon from '../../icons/penguin.webp'
import chineseIcon from '../../icons/chinese.webp'
import mexicanIcon from '../../icons/taco.webp'
import pizzaIcon from '../../icons/pizza.webp'
import pastaIcon from '../../icons/pasta.webp'
import sushiIcon from '../../icons/sushi.webp'
import americanIcon from '../../icons/burger.webp'
import hotdogIcon from '../../icons/hotdog.webp'
import thaiIcon from '../../icons/thai.webp'
import irishIcon from '../../icons/irish.webp'
import indianIcon from '../../icons/indian.webp'
import frenchIcon from '../../icons/french.webp'
import dartsIcon from '../../icons/darts.webp'
import englishIcon from '../../icons/english.webp'
import beerIcon from '../../icons/beer.webp'
import ramenIcon from '../../icons/ramen.webp'
import sandwichesIcon from '../../icons/sandwiches.webp'
import seafoodIcon from '../../icons/seafood.webp'
import hawaiianIcon from '../../icons/hawaiian.webp'
import halalIcon from '../../icons/halal.webp'
import dessertIcon from '../../icons/dessert.webp'
import kebabIcon from '../../icons/kebab.webp'
import vietnameseIcon from '../../icons/vietnamese.webp'
import jamaicanIcon from '../../icons/jamaican.webp'
import coffeeIcon from '../../icons/coffee.webp'
import juiceBarIcon from '../../icons/juiceBar.webp'
import mediterraneanIcon from '../../icons/mediterranean.webp'
import koreanIcon from '../../icons/korean.webp'
import cajunIcon from '../../icons/cajun.webp'
import wineIcon from '../../icons/wine.webp'
import bowlingIcon from '../../icons/bowling.webp'
import cubanIcon from '../../icons/cuban.webp'
import basqueIcon from '../../icons/basque.webp'
import japaneseIcon from '../../icons/japanese.webp'
import indonesianIcon from '../../icons/indonesian.webp'
import africanIcon from '../../icons/african.webp'
import bubbleTeaIcon from '../../icons/bubbleTea.webp'
import filipinoIcon from '../../icons/filipino.webp'
import germanIcon from '../../icons/german.webp'
import lebaneseIcon from '../../icons/lebanese.webp'
import fusionIcon from '../../icons/fusion.webp'
import spanishIcon from '../../icons/spanish.webp'
import ethiopianIcon from '../../icons/ethiopian.webp'
import elSalvadorIcon from '../../icons/elSalvador.webp'

export const iconSwitch = (tag, that) => {
  switch(tag){
        case 'el salvadorian':
          that.setState({iconImage:elSalvadorIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'ethiopian':
          that.setState({iconImage:ethiopianIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'spanish':
          that.setState({iconImage:spanishIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'fusion':
          that.setState({iconImage:fusionIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'lebanese':
          that.setState({iconImage:lebaneseIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'german':
          that.setState({iconImage:germanIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'filipino':
          that.setState({iconImage:filipinoIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'bubble tea':
          that.setState({iconImage:bubbleTeaIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'african':
          that.setState({iconImage:africanIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'indonesian':
          that.setState({iconImage:indonesianIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'japanese':
          that.setState({iconImage:japaneseIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'basque':
          that.setState({iconImage:basqueIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'cuban':
          that.setState({iconImage:cubanIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'bowling':
          that.setState({iconImage:bowlingIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'wine':
          that.setState({iconImage:wineIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'cajun':
          that.setState({iconImage:cajunIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'korean':
          that.setState({iconImage:koreanIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'mediterranean':
          that.setState({iconImage:mediterraneanIcon, iconSize: 60, iconPadding: "50%"});
          break;
        case 'juice bar':
          that.setState({iconImage:juiceBarIcon, iconSize: 65, iconPadding: "50%"});
          break;
        case 'coffee':
          that.setState({iconImage:coffeeIcon, iconSize: 65, iconPadding: "50%"});
          break;
        case 'jamaican':
          that.setState({iconImage:jamaicanIcon, iconSize: 60, iconPadding: "50%"});
          break;
        case 'vietnamese':
          that.setState({iconImage:vietnameseIcon, iconSize: 70, iconPadding: "50%"});
          break;
        case 'kebab':
          that.setState({iconImage:kebabIcon, iconSize: 80, iconPadding: "50%"});
          break;
        case 'dessert':
          that.setState({iconImage:dessertIcon, iconSize: 60, iconPadding: "50%"});
          break;
        case 'halal':
          that.setState({iconImage:halalIcon, iconSize: 65, iconPadding: "50%"});
          break;
        case 'hawaiian':
          that.setState({iconImage:hawaiianIcon, iconSize: 65, iconPadding: "50%"});
          break;
        case 'seafood':
          that.setState({iconImage:seafoodIcon, iconSize: 55, iconPadding: "50%"});
          break;
        case 'sandwiches':
          that.setState({iconImage:sandwichesIcon, iconSize: 50, iconPadding: "50%"});
          break;
        case 'ramen':
          that.setState({iconImage:ramenIcon, iconSize: 63, iconPadding: "50%"});
          break;
        case 'brewery':
          that.setState({iconImage:beerIcon, iconSize: 63, iconPadding: "50%"});
          break;
        case 'english':
          that.setState({iconImage:englishIcon, iconSize: 80, iconPadding: "50%"});
          break;
        case 'darts':
          that.setState({iconImage:dartsIcon, iconSize: 60, iconPadding: "20%"});
          break;
        case 'french':
          that.setState({iconImage:frenchIcon, iconSize: 55, iconPadding: "0%"});
          break;
        case 'indian':
          that.setState({iconImage:indianIcon, iconSize: 55, iconPadding: "20%"});
          break;
        case 'irish':
          that.setState({iconImage:irishIcon, iconSize: 55, iconPadding: "30%"});
          break;
        case 'chinese':
          that.setState({iconImage:chineseIcon, iconSize: 70, iconPadding: "30%"});
          break;
        case 'pizza':
          that.setState({iconImage:pizzaIcon, iconSize: 60, iconPadding: "20%"});
          break;
        case 'mexican':
          that.setState({iconImage:mexicanIcon, iconSize: 60, iconPadding: "30%"});
          break;
        case 'american':
          that.setState({iconImage:americanIcon, iconSize: 57, iconPadding: "30%"});
          break;
        case 'hotdog':
          that.setState({iconImage:hotdogIcon, iconSize: 50, iconPadding: "30%"});
          break;
        case 'pasta':
          that.setState({iconImage:pastaIcon, iconSize: 50, iconPadding: "20%"});
          break;
        case 'sushi':
          that.setState({iconImage:sushiIcon, iconSize: 60, iconPadding: "30%"});
          break;
        case 'thai':
          that.setState({iconImage:thaiIcon, iconSize: 70, iconPadding: "20%"});
          break;
        default:
          that.setState({iconImage:tagIcon});
          break;
        }
}

// <a href='https://webptree.com/so/hand-drawn-style'>hand drawn style webp from webptree.com</a>